export default __webpack_public_path__ + "static/media/A16.3384ce9d.png";